"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgDownload(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M25.2 13h4.333C31.448 13 33 14.471 33 16.286v16.428C33 34.53 31.448 36 29.533 36H10.467C8.552 36 7 34.529 7 32.714V16.286C7 14.47 8.552 13 10.467 13H14.8", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 22l5-4M15 18l5 4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 4v18", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgDownload;
//# sourceMappingURL=Download.js.map